class MobileSearch {
  constructor() {
    this.overlay = document.querySelector(".js-mobile-search-overlay");
    this.openButton = document.querySelector(".js-mobile-search-open");
    this.closeButton = document.querySelector(".js-mobile-search-close");
    this.searchInput = document.querySelector("#mobile-search-input");
    this.searchForm = document.querySelector(".mobile-search__form");
    this.inputWrapper = document.querySelector(".mobile-search__input-wrapper");

    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.overlay || !this.openButton || !this.closeButton) {
      console.warn("Mobile search elements not found");
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    // Open search popup
    this.openButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.openSearch();
    });

    // Close search popup
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeSearch();
    });

    // Close on overlay click
    this.overlay.addEventListener("click", (e) => {
      if (e.target === this.overlay) {
        this.closeSearch();
      }
    });

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.closeSearch();
      }
    });

    // Handle form submission
    if (this.searchForm) {
      this.searchForm.addEventListener("submit", (e) => {
        this.handleSearchSubmit(e);
      });
    }

    // Handle input changes for predictive search
    if (this.searchInput) {
      this.searchInput.addEventListener("input", (e) => {
        this.handleInputChange(e);
      });
    }
  }

  openSearch() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.overlay.style.display = "flex";

    // Trigger reflow to ensure display change is applied
    this.overlay.offsetHeight;

    // Add open class for animation
    this.overlay.classList.add("is-open");

    // Focus the search input immediately
    if (this.searchInput) {
      this.searchInput.focus();
      // Move cursor to end of input
      this.searchInput.setSelectionRange(
        this.searchInput.value.length,
        this.searchInput.value.length
      );
    }

    // Prevent body scroll
    document.body.style.overflow = "hidden";
  }

  closeSearch() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.overlay.classList.remove("is-open");

    // Hide overlay immediately
    this.overlay.style.display = "none";

    // Restore body scroll
    document.body.style.overflow = "";

    // Reset search - clear input and predictive results
    this.resetSearch();
  }

  resetSearch() {
    // Clear search input
    if (this.searchInput) {
      this.searchInput.value = "";
    }

    // Clear predictive search results
    this.clearPredictiveResults();
  }

  handleSearchSubmit(e) {
    const searchTerm = this.searchInput.value.trim();

    if (!searchTerm) {
      e.preventDefault();
      this.searchInput.focus();
      return;
    }

    // Form will submit naturally
  }

  handleInputChange(e) {
    const searchTerm = e.target.value.trim();

    // Clear predictive results when input is empty
    if (!searchTerm) {
      this.clearPredictiveResults();
    }
  }

  clearPredictiveResults() {
    const resultsContainer = document.querySelector(
      "#mobile-predictive-search-results"
    );
    if (resultsContainer) {
      resultsContainer.innerHTML = "";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.mobileSearch = new MobileSearch();
});
